var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { TextField, Typography } from '@mui/material';
import { useState } from 'react';
import { useParams, useSearchParams } from 'react-router-dom';
import { ErrorBoundary } from '../components/ErrorBoundary';
import { Rs2fEditor } from '../components/Rs2fEditor';
import { parse, parseModules } from '../parsing/parse';
import { useFilterConfigStore } from '../store/filterConfigurationStore';
import { useFilterStore } from '../store/filterStore';
import { applyModule } from '../utils/render';
var DOC_LINK_COMMENT = '// For docs visit https://github.com/Kaqemeex/loot-filters-ui/blob/main/module-system-docs/modular-filters-book/Readme.md';
var raise = function (error) {
    throw error;
};
export var EditorLoadedFilterPage = function () {
    var _a;
    var filterId = useParams().filterId;
    var _b = useFilterConfigStore(), filterConfigurations = _b.filterConfigurations, setFilterConfiguration = _b.setFilterConfiguration;
    var _c = useFilterStore(), filters = _c.filters, updateFilter = _c.updateFilter;
    var searchParams = useSearchParams()[0];
    var initialFile = searchParams.get('initialFile');
    if (!filterId || !filters[filterId]) {
        return (_jsx(ErrorBoundary, __assign({ error: new Error("Filter with id ".concat(filterId, " not found.")) }, { children: _jsx("div", { children: "No filter id" }) })));
    }
    var config = filterConfigurations[filterId];
    var defaultContent = {
        prefixRs2f: '/*@ define:module:prefix\nname: A Prefix Module\n*/\n' +
            DOC_LINK_COMMENT,
        suffixRs2f: '/*@ define:module:suffix\nname: A Suffix Module\n*/\n' +
            DOC_LINK_COMMENT,
    };
    var filesContent = __assign(__assign(__assign(__assign({}, defaultContent), ((config === null || config === void 0 ? void 0 : config.prefixRs2f) ? { prefixRs2f: config.prefixRs2f } : {})), ((config === null || config === void 0 ? void 0 : config.suffixRs2f) ? { suffixRs2f: config.suffixRs2f } : {})), (filters[filterId] ? { filterRs2f: filters[filterId].rs2f } : {}));
    var initialFileValid = [
        'filterRs2f',
        'prefixRs2f',
        'suffixRs2f',
    ].includes(initialFile || '');
    var _d = useState(initialFileValid
        ? initialFile
        : 'prefixRs2f'), selected = _d[0], setSelected = _d[1];
    var setContent = function (id, content) {
        var _a;
        if (id === 'filterRs2f') {
            var filter = parse(content, false, { name: 'update' });
            var newFilter = __assign(__assign(__assign({}, filters[filterId]), filter.filter), { name: filters[filterId].name, id: filters[filterId].id, 
                // ...(modules.modules ? { modules: modules.modules } : {}),
                rs2f: content });
            updateFilter(newFilter);
        }
        else if (id === 'prefixRs2f' || id === 'suffixRs2f') {
            setFilterConfiguration(filterId, __assign(__assign({}, config), (_a = {}, _a[id] = content, _a)));
        }
        else {
            // nothing
        }
    };
    var selectedModules = ((_a = parseModules(filesContent[selected] || '')) === null || _a === void 0 ? void 0 : _a.modules) || [];
    return (_jsx(Rs2fEditor, { selected: selected, setEditorContent: setContent, setSelected: setSelected, filesContent: filesContent, configOnChange: function (config) {
            var content = filesContent[selected];
            if (!content) {
                return;
            }
            if (selectedModules) {
                var newContent = selectedModules
                    .map(function (m) {
                    return applyModule(m, config.inputConfigs, undefined);
                })
                    .join('');
                setContent(selected, newContent);
            }
        }, warningComponent: _jsx(Typography, __assign({ variant: "h5", color: "error" }, { children: selected === 'filterRs2f' && filters[filterId].source
                ? 'Changes will not carry forward if filter updates'
                : null })), extraTabComponent: _jsxs("div", __assign({ style: {
                width: '80%',
                display: 'flex',
                flexDirection: 'row',
                gap: 2,
            } }, { children: [_jsx(TextField, { label: "Filter Name", value: filters[filterId].name, onChange: function (e) {
                        updateFilter(__assign(__assign({}, filters[filterId]), { name: e.target.value }));
                    } }), _jsx(TextField, { sx: { ml: 2, width: '20rem' }, label: "Filter Description", value: filters[filterId].description, onChange: function (e) {
                        updateFilter(__assign(__assign({}, filters[filterId]), { description: e.target.value }));
                    } })] })), options: [
            { label: 'Prefix', value: 'prefixRs2f' },
            { label: 'Filter', value: 'filterRs2f' },
            { label: 'Suffix', value: 'suffixRs2f' },
        ] }));
};
